import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { CreateApplicationRequest, CreateApplicationResponse, IApplicationView} from '../../Types/Application'
import { IClientApplicationView, ITalentApplicationView } from '../../Types/Application';
import { buildUrl } from '../../Utils/Api';
import { AppSettings } from '../../Utils/Settings';

const base = 'application';
export const applicationApi = createApi({
    reducerPath: 'applicationApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl,
        prepareHeaders: async (headers, {getState}) =>{
            headers.set(
                'Authorization',
                `Bearer ${(localStorage.getItem('token') ?? '')}`
            );
            return headers;
        }
    }),
    tagTypes: ['ApplicationByJob', 'ApplicationByTalent', 'Applications'],
    endpoints: (builder) => ({     
        createApplication: builder.mutation<CreateApplicationResponse, CreateApplicationRequest>({
            query: (body) => ({
                url: buildUrl(base, 'apply'),
                method: "POST",
                body
            })
        }),   
        getApplications: builder.query<IApplicationView[], {talent_locator: string, client_locator: string}>({
            providesTags:['Applications'],
            query: ({ client_locator, talent_locator }) => ({
                url: `/application?client_locator=${client_locator}&talent_locator=${talent_locator}`,
                method: "GET"
            })
        }),   
        getApplicationsByJob: builder.query<IClientApplicationView, string>({
            providesTags:['ApplicationByJob'],
            query: (locator) => ({
                url: buildUrl(base, `by-job/${locator}`),
                method: "GET"
            })
        }),   
        getApplicationsByTalent: builder.query<ITalentApplicationView[], string>({
            providesTags:['ApplicationByTalent'],
            query: (locator) => ({
                url: buildUrl(base, `by-talent/${locator}`),
                method: "GET"
            })
        }),
        updateApplication: builder.mutation<any, any>({
            query: (body) => ({
                url: buildUrl(base, `status`),
                method: "PUT",
                body
            })
        }),
        deleteApplicationsByJob: builder.mutation<any, string>({
            query: (locator) => ({
                url: buildUrl(base, `${locator}`),
                method: "DELETE"
            })
        }),
    }),
})

export const {
    useGetApplicationsByJobQuery,
    useCreateApplicationMutation,
    useGetApplicationsByTalentQuery,
    useUpdateApplicationMutation,
    useDeleteApplicationsByJobMutation,
    useGetApplicationsQuery
} = applicationApi